import {AfterViewInit, Component, ViewChild} from '@angular/core';
import {MatDialog}                           from '@angular/material/dialog';
import {MatPaginator, PageEvent}             from '@angular/material/paginator';
import {MatSnackBar}                         from '@angular/material/snack-bar';
import {MatTableDataSource}                  from '@angular/material/table';
import {ApiService}                          from '@src/app/shared/services/api.service';
import {WalkthroughService}                  from '@src/app/shared/services/walkthrough/walkthrough.service';
import {query}                               from 'js-query-builder';
import {RolesService}                        from '../../services/roles.service';
import {DialogComponent}                     from '@src/app/shared/components/dialog/dialog.component';

@Component({
    standalone: false,
    selector: 'app-roles',
    templateUrl: './roles.component.html',
    styleUrls: ['./roles.component.css']
})
export class RolesComponent implements AfterViewInit
{
    @ViewChild('defaultRolesPaginator') public defaultRolesPaginator!: MatPaginator;
    @ViewChild('customRolesPaginator') public customRolesPaginator!: MatPaginator;
    public displayedColumns: string[] = ['name', 'permissions_count', 'user_count', 'actions'];
    public default_roles: MatTableDataSource<any> = new MatTableDataSource();
    public default_roles_total_rows = 0;
    public default_roles_page_size = 50;
    public default_roles_current_page = 0;
    public custom_roles: MatTableDataSource<any> = new MatTableDataSource();
    public custom_roles_total_rows = 0;
    public custom_roles_page_size = 50;
    public custom_roles_current_page = 0;
    public pageSizeOptions: number[] = [5, 10, 25, 100];

    constructor(
        public walkthroughService: WalkthroughService,
        private apiService: ApiService,
        private dialog: MatDialog,
        private roleService: RolesService,
        private snackbar: MatSnackBar
    )
    {
        this.walkthroughService.start('settings.roles', false);
    }

    public ngAfterViewInit(): void
    {
        this.loadDefaultRoles();
        this.loadCustomRoles();
    }

    public loadDefaultRoles(): void
    {
        const default_url = query('roles')
            .filter('guard_name', 'api')
            .filter('author_id', 0)
            .build();

        this.apiService.queryList(default_url, this.default_roles_current_page + 1, this.default_roles_page_size)
            .subscribe({
                next: response => {
                    this.default_roles = new MatTableDataSource<any>(response.data ?? []);
                    this.default_roles_total_rows = response.meta.total;
                    this.defaultRolesPaginator.pageIndex = this.default_roles_current_page;
                    this.defaultRolesPaginator.length = this.default_roles_total_rows;
                    this.default_roles.paginator = this.defaultRolesPaginator;
                },
                error: error => {
                    this.apiService.handleError(error);
                }
            });
    }

    public loadCustomRoles(): void
    {
        const custom_url = query('roles')
            .filter('guard_name', 'api')
            .filter('author_id-gt', 0)
            .build();

        this.apiService.queryList(custom_url, this.custom_roles_current_page + 1, this.custom_roles_page_size)
            .subscribe({
                next: response => {
                    this.custom_roles = new MatTableDataSource<any>(response.data ?? []);
                    this.custom_roles_total_rows = response.meta.total;
                    this.customRolesPaginator.pageIndex = this.custom_roles_current_page;
                    this.customRolesPaginator.length = this.custom_roles_total_rows;
                    this.custom_roles.paginator = this.customRolesPaginator;
                },
                error: error => {
                    this.apiService.handleError(error);
                }
            });
    }

    public defaultRolesPageChanged(event: PageEvent): void
    {
        this.default_roles_page_size = event.pageSize;
        this.default_roles_current_page = event.pageIndex;
        this.loadDefaultRoles();
    }

    public customRolesPageChanged(event: PageEvent): void
    {
        this.custom_roles_page_size = event.pageSize;
        this.custom_roles_current_page = event.pageIndex;
        this.loadCustomRoles();
    }

    public editRole(role = null): void
    {
        this.roleService.editRole(role);
    }

    public createRole(): void
    {
        this.roleService.editRole({create: true});
    }

    public onDelete(roleId: number): void
    {
        const confirmDialogRef = this.dialog.open(DialogComponent, {
            data: {
                title: 'Delete Role',
                message: 'Are you sure you want to delete this role? You can\'t undo this action.',
                type: 'danger',
                confirmButtonLabel: 'Delete'
            }
        });

        confirmDialogRef.afterClosed().subscribe((confirm) => {
            if (confirm) {
                this.apiService.delete('roles', roleId).subscribe({
                    next: response => {
                        this.snackbar.open('Role archived.', 'Ok.', {duration: 2500});
                        this.loadCustomRoles();
                    },
                    error: error => {
                        this.snackbar.open('Error deleting role', 'Ok', {duration: 5000});
                    }
                });
            }
        });
    }

}
